import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class PicStoriesQueryService {

    public CREATE_PIC_STORIES: any;
    public FETCH_PIC_STORIES_DATA: any;

    constructor(public apollo: Apollo) {

        /* To create pic stories */
        this.CREATE_PIC_STORIES = gql` 
          mutation CREATE_PIC_STORIES($input: CreatePicStoryInput!) {
            createPicStory(input: $input) {
                picStory{
                  userId
                 }
              }
           }
        `;

        this.FETCH_PIC_STORIES_DATA =
            gql`
            query allPictureStories($userId:UUID){                           
                allPicStories(condition:{userId:$userId}) {
                    nodes {
                        id
                        section
                        descFirst
                        descThird
                        descSecond
                        userId
                    }
                }
            }
        `
    }

    CREATE_PIC_STORY(values, userId): any {
       
        return this.apollo.mutate({
            mutation: this.CREATE_PIC_STORIES,
            variables: {
                "input": {
                    "picStory": {
                        "descFirst": values.first,
                        "descSecond": values.second,
                        "descThird": values.third,
                        "section": values.section,
                        "userId": userId
                    }
                }
            }
        })
    }

    FETCH_PIC_STORIES(userId): any {
        return this.apollo
            .watchQuery({
                query: this.FETCH_PIC_STORIES_DATA
                ,
                variables:
                {
                    "userId": userId
                },
                fetchPolicy: 'network-only'
            });
    }

}


// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/gql-query-mutation/picStories.ts